import type { ColorSwatch, ColorSwatchCache } from '~/types/colorSwatch'

/**
 * Looks up a color facet's swatch by its localised `color.name` value (faceting is
 * only permitted on that field, so the lookup is by name, not by a stable id).
 * Returns `undefined` when the locale or the name isn't in the cache — callers render
 * no swatch in that case rather than a broken one.
 */
export function getColorSwatch(cache: ColorSwatchCache, locale: string, name: string): ColorSwatch | undefined {
    return cache[locale]?.[name]
}
